module.exports = __webpack_public_path__ + "static/media/sxf00.166ba027.png";